import { useEffect, useRef, useState } from "react";
import { AuthContext } from "./AuthContext";
import { User } from "../../types/User";
import { useApi } from "../../hooks/useApi";

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [user, setUser] = useState<User | null>(null);
  const [error, setError] = useState("");
  const api = useApi();
  const refApi = useRef(api);

  useEffect(() => {
    const persisteUser = async () => {
      // console.log("Valor do usuário antes do logi: ", user);

      const storageData = localStorage.getItem("user");
      if (storageData) {
        const dataUser = await refApi.current.validateUser(storageData);
        setUser(dataUser.user);
        if (dataUser) {
          setUser(dataUser.user);
        }
      }
    };

    persisteUser();
  }, [refApi]);

  const signin = async (email: string, password: string) => {
    const data = await api.signin(email, password);
    console.log("Dados do Usuário: ", data)
    if (data.user && data.token) {
      setUser(data.user);
      localStorage.setItem("user", JSON.stringify(data.user));
      setToken(data.token);

      return true;
    }

    return false;
  };

  const signout = async () => {
    await api.logout();
    setUser(null);
  };

  const setToken = (token: string) => {
    localStorage.setItem("authToken", token);
  };

  return (
    <AuthContext.Provider value={{ user, signin, signout }}>
      {children}
    </AuthContext.Provider>
  );
};
